import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Typography,
  Box,
} from '@material-ui/core';
import { ContentWrapper } from '../../shared/ContentWrapper/ContentWrapper';
import { getShopperOrders } from '../../api/shopperOrders';
import {
  setMyOrders,
  setLoading,
  setError,
} from '../../features/shopperOrders/shopperOrdersSlice';
import { getToken } from '../../services/auth';

export const MyOrders = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { myOrders, loading } = useSelector((state) => state.shopperOrders);

  const fetchMyOrders = async () => {
    dispatch(setLoading(true));
    try {
      const response = await getShopperOrders({ token: getToken() });
      dispatch(setMyOrders(response.results || []));
    } catch (error) {
      dispatch(setError(error.message));
    } finally {
      dispatch(setLoading(false));
    }
  };

  useEffect(() => {
    fetchMyOrders();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const handleViewDetail = (id) => {
    navigate(`/shopper/order/${id}`);
  };

  const orders = myOrders || [];

  return (
    <ContentWrapper>
      <Box mb={3}>
        <Typography variant="h4">
          {t('ShopperOrders.myOrdersTitle', 'My Orders')}
        </Typography>
      </Box>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{t('ShopperOrders.id', 'ID')}</TableCell>
              <TableCell>{t('ShopperOrders.reference', 'Reference')}</TableCell>
              <TableCell>{t('ShopperOrders.store', 'Store')}</TableCell>
              <TableCell>{t('ShopperOrders.status', 'Status')}</TableCell>
              <TableCell align="right">
                {t('ShopperOrders.actions', 'Actions')}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {orders.map((order) => {
              const statusText =
                order.status && typeof order.status === 'object'
                  ? order.status.description || 'N/A'
                  : order.status || 'N/A';

              return (
                <TableRow key={order.id}>
                  <TableCell>{order.id}</TableCell>
                  <TableCell>{order.reference}</TableCell>
                  <TableCell>
                    {order.branch_store_name ||
                      (order.branch_store && order.branch_store.name) ||
                      ''}
                  </TableCell>
                  <TableCell>{statusText}</TableCell>
                  <TableCell align="right">
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={() => handleViewDetail(order.id)}>
                      {t('ShopperOrders.view', 'View')}
                    </Button>
                  </TableCell>
                </TableRow>
              );
            })}
            {orders.length === 0 && !loading && (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  {t('ShopperOrders.noMyOrders', 'No active orders')}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </ContentWrapper>
  );
};
